import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, Coffee, Flame, Shirt } from "lucide-react";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";

const categories = [
  {
    id: "mugs",
    title: "Mugs",
    description: "Start your day with humor and hormones",
    icon: Coffee,
    path: "/shop/mugs",
    bgColor: "bg-[#FFE5E5]"
  },
  {
    id: "candles",
    title: "Scented Candles",
    description: "Aromatherapy for your wellness journey",
    icon: Flame,
    path: "/shop/candles",
    bgColor: "bg-[#E8DFF5]"
  },
  {
    id: "tees",
    title: "T-Shirts",
    description: "Comfortable statements for everyday wear",
    icon: Shirt,
    path: "/shop/tees",
    bgColor: "bg-[#D4F1D4]"
  },
  {
    id: "sweatshirts",
    title: "Sweatshirts",
    description: "Cozy comfort meets empowering messages",
    icon: Shirt,
    path: "/shop/sweatshirts",
    bgColor: "bg-[#E3E8F8]"
  },
];

const Shop = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20 flex flex-col">
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Button variant="ghost" onClick={() => navigate('/')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          <h1 className="text-2xl font-bold">Her Season Shop</h1>
          <CartDrawer />
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 flex-1">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Wellness Essentials</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Discover products designed to support your wellness journey through menopause
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <Card
                key={category.id}
                className="group cursor-pointer overflow-hidden hover:shadow-2xl transition-all duration-300 border-0 shadow-lg"
                onClick={() => navigate(category.path)}
              >
                <div className={`p-12 ${category.bgColor}`}>
                  <div className="flex items-start gap-6 mb-8">
                    <div className="w-16 h-16 rounded-2xl bg-white/60 backdrop-blur flex items-center justify-center flex-shrink-0">
                      <Icon className="h-8 w-8 text-[#5B8C5A]" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-3xl font-bold mb-3 text-[#2D3648]">{category.title}</h3>
                      <p className="text-[#6B7280] text-lg leading-relaxed">{category.description}</p>
                    </div>
                  </div>
                  <Button 
                    className="w-full bg-[#5B8C5A] hover:bg-[#4A7349] text-white font-semibold py-6 text-lg rounded-xl shadow-md transition-all duration-200"
                  >
                    Browse {category.title}
                  </Button>
                </div>
              </Card>
            );
          })}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Shop;
